import React, { useState } from 'react';
import Cookies from 'js-cookie';

export const Context = React.createContext();

//export const Provider = WebsiteContext.Provider;
export const Consumer = Context.Consumer;

export const Provider = (props) => {

  const [authenticatedUser, setAuthenticatedUser] = useState(JSON.parse(Cookies.get('authenticatedUser') || '{}') || null)

  const signIn = (firstName, token, id) => {
    let user = {
      firstName,
      token,
      id
    };
    setAuthenticatedUser(user)
    const cookieOptions = {
      expires: 1 // 1 day
    };
    Cookies.set('authenticatedUser', JSON.stringify(user), cookieOptions);

    return user;
  }

  const signOut = () => {
    setAuthenticatedUser(null);
    Cookies.remove('authenticatedUser');
  }

  return (
    <Context.Provider
      value={{
        authenticatedUser,
        actions: {
          signIn,
          signOut
        },
      }}>
      {props.children}
    </Context.Provider>
  );
}


/**
 * A higher-order component that wraps the provided component in a Context Consumer component.
 * @param {class} Component - A React component.
 * @returns {function} A higher-order component.
 */

export default function withContext(Component) {
  return function ContextComponent(props) {
    return (
      <Context.Consumer>
        {context => <Component {...props} context={context} />}
      </Context.Consumer>
    );
  }
}
